export default __webpack_public_path__ + "static/media/walletconnect.f4549d49.svg";